import React, { Fragment, Component } from "react";

class Box extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Fragment>
                <div className={this.props.classToBeApplied}>
                    <div
                        className="card-shadow-info m-3 widget-chart widget-chart2 card"
                        style={{ borderWidth: "1px", borderColor: this.props.color }}
                    >
                        <div className="widget-content">
                            <div className="widget-content-outer">
                                <div className="widget-content">
                                    <div className="widget-numbers m-0" style={{ color: this.props.color, fontSize: "40px" }}>{this.props.value}</div>
                                </div>
                                <div className="widget-content fsize-1">
                                    <div className="text-center opacity-8 mt-2"><span style={{ fontWeight: "bold" }}>{this.props.text}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Box;